<template>
  <component :is="component" :paginationData="paginationData" v-if="component"/>
</template>

<script>
export default {
  name: "PortfolioListLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    listLayout: {},
    historyData: {
      type: Array,
      default: () => {
        return []
      }
    },
    paginationData: {
      type: Object,
      default: {
        total: 0,
        page: 0,
        size: 0,
      }
    },
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.listLoader();
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.listLayout) {
        return null
      }
      return () => import(`@/template/portfolio/list/${this.listLayout}`)
    },
  },
  methods:{
    listLoader() {
      this.loader()
          .then(() => {
            this.component = () => this.loader()
          })
          .catch(() => {
            this.component = () => import('@/template/portfolio/list/PortfolioListDefaultLayout')
          })
    }
  },
  watch: {

  },
}
</script>

<style scoped>

</style>